import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingCart, Leaf, Home, Dumbbell, Newspaper, Star, ShieldPlus } from 'lucide-react';
import { useCart } from '../context/CartContext';

const Navbar = () => {
  const location = useLocation();
  const { getCartCount } = useCart();
  
  const navLinks = [
    { name: 'דף הבית', path: '/' },
    { name: 'חיזוק האון הגברי', path: '/products' },
    { name: 'תזונה וכושר', path: '/fitness' },
    { name: 'מאמרים', path: '/articles' },
    { name: 'המלצות', path: '/recommendations' },
  ];

  const mobileLinks = [
    { name: 'בית', path: '/', icon: Home },
    { name: 'חיזוק האון הגברי', path: '/products', icon: ShieldPlus },
    { name: 'תזונה וכושר', path: '/fitness', icon: Dumbbell },
    { name: 'מאמרים', path: '/articles', icon: Newspaper },
    { name: 'המלצות', path: '/recommendations', icon: Star },
  ];
  
  const cartCount = getCartCount();
  
  return (
    <>
      {/* Desktop Navbar */}
      <nav className="sticky top-0 z-50 glass border-b border-stone-100/50">
        <div className="container">
          <div className="flex items-center justify-between h-16 md:h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2 group" data-testid="navbar-logo">
              <img 
                src="https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/sllsqwqk_%D7%A2%D7%99%D7%A6%D7%95%D7%91%20%D7%9C%D7%9C%D7%90%20%D7%A9%D7%9D%20%2824%29.png"
                alt="בריאות הגבר"
                className="w-10 h-10 object-contain group-hover:scale-110 transition-transform duration-300"
              />
              <span className="text-lg md:text-2xl font-bold text-[#8B4513]" style={{ fontFamily: 'Heebo, sans-serif' }}>
                בריאות הגבר
              </span>
            </Link>
            
            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`nav-link-${link.path}`}
                  className={`text-base font-medium transition-colors duration-300 hover:text-[#D97706] ${
                    location.pathname === link.path ? 'text-[#D97706]' : 'text-stone-600'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
            </div>
            
            {/* Cart */}
            <div className="flex items-center gap-4">
              <Link
                to="/cart"
                data-testid="cart-button"
                className="relative p-2 hover:bg-stone-100 rounded-full transition-colors"
              >
                <ShoppingCart className="w-6 h-6 text-[#2C3E2D]" />
                {cartCount > 0 && (
                  <span className="absolute -top-1 -right-1 bg-[#D97706] text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center" data-testid="cart-count">
                    {cartCount}
                  </span>
                )}
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Bottom Tab Bar */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t-2 border-[#D97706]/20 shadow-[0_-4px_20px_rgba(0,0,0,0.12)]" data-testid="mobile-tab-bar">
        <div className="flex items-center justify-around h-20 px-1">
          {mobileLinks.map((link) => {
            const Icon = link.icon;
            const isActive = location.pathname === link.path;
            return (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`mobile-tab-${link.path}`}
                className={`flex flex-col items-center justify-center gap-1 flex-1 py-2 rounded-xl transition-all duration-200 ${
                  isActive ? 'text-[#D97706] bg-[#D97706]/10' : 'text-stone-500'
                }`}
              >
                <Icon className={`${isActive ? 'w-7 h-7' : 'w-6 h-6'}`} strokeWidth={isActive ? 2.5 : 2} />
                <span className={`${isActive ? 'text-[11px] font-bold' : 'text-[10px] font-semibold'} leading-tight text-center`} style={{ fontFamily: 'Heebo, sans-serif' }}>
                  {link.name}
                </span>
              </Link>
            );
          })}
          <Link
            to="/cart"
            data-testid="mobile-tab-cart"
            className={`flex flex-col items-center justify-center gap-1 flex-1 py-2 rounded-xl transition-all duration-200 relative ${
              location.pathname === '/cart' ? 'text-[#D97706] bg-[#D97706]/10' : 'text-stone-500'
            }`}
          >
            <ShoppingCart className={`${location.pathname === '/cart' ? 'w-7 h-7' : 'w-6 h-6'}`} strokeWidth={location.pathname === '/cart' ? 2.5 : 2} />
            {cartCount > 0 && (
              <span className="absolute top-1 right-1/2 translate-x-4 bg-[#D97706] text-white text-[10px] font-bold rounded-full w-5 h-5 flex items-center justify-center">
                {cartCount}
              </span>
            )}
            <span className={`${location.pathname === '/cart' ? 'text-[11px] font-bold' : 'text-[10px] font-semibold'}`} style={{ fontFamily: 'Heebo, sans-serif' }}>
              סל
            </span>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Navbar;
